<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Signature from "@/pages/components/form/input-only/signature.vue";

export default {
	mixins: [formInput],
	components: {FormGroup, Signature},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<Signature
			v-bind="$attrs"
			:form="form"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		/>
	</FormGroup>
</template>